import { useLayoutEffect, useRef } from 'react'
import cx from 'classnames'

import { SelectedImage, HTMLInputEvent, SetState } from 'types'
import Preview from './Preview'
import { ReactComponent as ImageAddIcon } from 'assets/icons/imageAdd24.svg'

import Styles from './UploadFromComputer.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
interface Props {
  stagedImages: SelectedImage[]
  selectedImages: SelectedImage[]
  setDefaultUploadContainer: SetState<boolean>
  setSelectedImages: SetState<SelectedImage[]>
  setStagedImages: SetState<SelectedImage[]>
  multiSelect?: boolean
}

const UploadFromComputer = ({
  selectedImages,
  stagedImages,
  multiSelect,
  setDefaultUploadContainer,
  setStagedImages,
  setSelectedImages,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const { isMobile } = useResponsiveDesign()

  useLayoutEffect(() => {
    inputRef.current?.click()
  }, [inputRef])

  const handleOnChange = async (e: HTMLInputEvent) => {
    const files = Array.from(e.target.files || [])
    const newSelectedImages = files.map((file) => {
      const image: SelectedImage = {
        url: URL.createObjectURL(file),
        file: file,
      }

      return image
    })
    setDefaultUploadContainer(newSelectedImages.length ? false : true)
    setStagedImages([...selectedImages, ...newSelectedImages])
    setSelectedImages([...selectedImages, ...newSelectedImages])
  }

  return (
    <div className={Styles.imageUploadContainer}>
      <Preview
        stagedImages={stagedImages}
        selectedImages={selectedImages}
        setSelectedImages={setSelectedImages}
        multiSelect={multiSelect}
        uploaderInputRef={inputRef}
        showAddImage
      />

      <label
        htmlFor="insert image"
        className={cx(Styles.insertImageLabel, { [Styles.hidden]: stagedImages.length > 0 || isMobile })}
      >
        <ImageAddIcon />
        <p>
          <button className={Styles.labelButton} onClick={() => inputRef.current?.click()}>
            Browse
          </button>
          images
        </p>
      </label>
      <input
        type="file"
        accept="image/*"
        className={Styles.insertImageInput}
        onChange={handleOnChange}
        ref={inputRef}
        multiple={multiSelect}
        name="insert image"
        id="insert image"
        data-testid="file-input"
      />
    </div>
  )
}

export default UploadFromComputer
